module.exports = "<div *ngIf=\"isResponseReady\" class=\"section\">\n    <h2>Response</h2>\n    <div *ngIf=\"responseMessage\">{{responseMessage}}</div>\n    <div *ngIf=\"dataschema\" class=\"res\">\n        <jsonforms class=\"jsf\" [schema]=\"dataschema\" [uischema]=\"uischema\" [data]=\"data\"></jsonforms>\n    </div>\n    <div *ngIf=\"dataschema\" class=\"button-container\">\n        <button class=\"response-button\" *ngFor=\"let relatedOperation of activeOperation.relatedOperations\" (click)=\"onClickRelatedOperation(relatedOperation)\">{{relatedOperation.getType()}}</button>\n     </div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/response/response.html
 ** module id = 797
 ** module chunks = 0
 **/